import config from 'config-base';
import StorageManager from '@/lib/Storage';

export const storageManager = new StorageManager(config.storageKey);
